import ManageCorporation from './manage_corporation';

export default ManageCorporation;
